import { PencilIcon } from 'lucide-react'
import React from 'react'
import { ActionIcon } from 'rizzui/action-icon'
import { Tooltip } from 'rizzui'

function ActionButton({
    icon,
    onClick,
    variant = "outline",
    color,
    tooltip,
    tooltipSize = "sm",
    tooltipPlacement = "bottom"
}) {
    const button = (
        <ActionIcon
            variant={variant}
            rounded="md"
            size="sm"
            className="border-gray-300 hover:border-gray-400 hover:bg-gray-50 transition-colors p-1"
            color={color}
            onClick={() => {
                if (onClick) onClick();
            }}
        >
            {icon ? icon : <PencilIcon className="w-4 h-4" />}
        </ActionIcon>
    );

    if (tooltip) {
        return (
            <Tooltip
                content={tooltip}
                placement={tooltipPlacement}
                size={tooltipSize}
            >
                {button}
            </Tooltip>
        );
    }

    return button;
}

export default ActionButton
